export default function FooterComponent() {
    return (
        <footer style={{ background: "#0a0a0a" }}>

            {/* Main footer body */}
            <div className="container-fluid px-5 py-5" style={{ maxWidth: "1100px", margin: "0 auto" }}>
                <div className="row pt-4 pb-3 g-5">

                    {/* Brand column */}
                    <div className="col-12 col-lg-4">
                        <a href="/" className="d-inline-flex align-items-center gap-2 text-decoration-none mb-4">
                            <CrossMark />
                            <span style={{ fontWeight: 700, fontSize: "0.875rem", color: "#fff", letterSpacing: "-0.01em" }}>
                                Extern Academy
                            </span>
                        </a>
                        <p className="mb-4" style={{ fontSize: "0.875rem", lineHeight: "1.7", color: "rgba(255,255,255,0.35)", maxWidth: "280px" }}>
                            High school students building and shipping real products.<br />
                            Think it. Build it.
                        </p>
                        <a
                            href="/apply"
                            className="d-inline-block text-white text-decoration-none"
                            style={{
                                fontSize: "0.7rem",
                                fontWeight: 600,
                                letterSpacing: "0.18em",
                                textTransform: "uppercase",
                                padding: "10px 20px",
                                border: "1px solid rgba(255,255,255,0.15)",
                                transition: "opacity 0.2s",
                            }}
                            onMouseEnter={e => e.currentTarget.style.opacity = "0.7"}
                            onMouseLeave={e => e.currentTarget.style.opacity = "1"}
                        >
                            Apply Now →
                        </a>
                    </div>

                    {/* Programs column */}
                    <div className="col-6 col-lg-2">
                        <p className="mb-4" style={{ fontSize: "0.65rem", fontWeight: 600, letterSpacing: "0.2em", textTransform: "uppercase", color: "rgba(255,255,255,0.25)" }}>
                            Programs
                        </p>
                        <ul className="list-unstyled mb-0" style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                            {[
                                { label: "2027 Startup Sprint", href: "/admissions/2027-startup-sprint" },
                                { label: "Founder Track",       href: "/admissions/founder-track" },
                                { label: "The Residency",       href: "/admissions/residency" },
                                { label: "Financial Aid",       href: "/financial-aid" },
                            ].map(({ label, href }) => (
                                <li key={href}>
                                    <FooterLink href={href} label={label} />
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Admissions column */}
                    <div className="col-6 col-lg-2">
                        <p className="mb-4" style={{ fontSize: "0.65rem", fontWeight: 600, letterSpacing: "0.2em", textTransform: "uppercase", color: "rgba(255,255,255,0.25)" }}>
                            Admissions
                        </p>
                        <ul className="list-unstyled mb-0" style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                            {[
                                { label: "Overview",         href: "/admissions" },
                                { label: "Apply Now",        href: "/apply" },
                                { label: "Partners",         href: "/partners" },
                                { label: "Contact",          href: "/contact-us" },
                                { label: "Privacy Policy",   href: "/privacy" },
                            ].map(({ label, href }) => (
                                <li key={href}>
                                    <FooterLink href={href} label={label} />
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Learn column */}
                    <div className="col-6 col-lg-2">
                        <p className="mb-4" style={{ fontSize: "0.65rem", fontWeight: 600, letterSpacing: "0.2em", textTransform: "uppercase", color: "rgba(255,255,255,0.25)" }}>
                            Learn
                        </p>
                        <ul className="list-unstyled mb-0" style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                            {[
                                { label: "Our Mission",       href: "/mission" },
                                { label: "About",             href: "/about" },
                                { label: "Definitions",       href: "/education/definitions" },
                                { label: "Meet the Founders", href: "/education/founders" },
                                { label: "Startup Trainer",   href: "/education/trainer" },
                            ].map(({ label, href }) => (
                                <li key={href}>
                                    <FooterLink href={href} label={label} />
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Stories column */}
                    <div className="col-6 col-lg-2">
                        <p className="mb-4" style={{ fontSize: "0.65rem", fontWeight: 600, letterSpacing: "0.2em", textTransform: "uppercase", color: "rgba(255,255,255,0.25)" }}>
                            Stories
                        </p>
                        <ul className="list-unstyled mb-0" style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                            {[
                                { label: "For Parents",        href: "/stories/parent-need-to-know" },
                                { label: "For Students",       href: "/stories/students-need-to-know" },
                                { label: "The Next Big Thing", href: "/stories/next-big-thing" },
                                { label: "Student Life", href: "/student-life" },
                                // { label: "Meet a Student",     href: "/stories/meet-a-student" },
                            ].map(({ label, href }) => (
                                <li key={href}>
                                    <FooterLink href={href} label={label} />
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Student Life column */}
                    {/*<div className="col-6 col-lg-2">*/}
                    {/*    <p className="mb-4" style={{ fontSize: "0.65rem", fontWeight: 600, letterSpacing: "0.2em", textTransform: "uppercase", color: "rgba(255,255,255,0.25)" }}>*/}
                    {/*        Student Life*/}
                    {/*    </p>*/}
                    {/*    <ul className="list-unstyled mb-0" style={{ display: "flex", flexDirection: "column", gap: "12px" }}>*/}
                    {/*        {[*/}
                    {/*            { label: "Overview",  href: "/student-life" },*/}
                    {/*            { label: "CEO",       href: "/student-life/ceo" },*/}
                    {/*            { label: "CMO",       href: "/student-life/cmo" },*/}
                    {/*            { label: "CTO",       href: "/student-life/cto" },*/}
                    {/*            { label: "CPO",       href: "/student-life/cpo" },*/}
                    {/*            { label: "COO",       href: "/student-life/coo" },*/}
                    {/*            { label: "CGO",       href: "/student-life/cgo" },*/}
                    {/*        ].map(({ label, href }) => (*/}
                    {/*            <li key={href}>*/}
                    {/*                <FooterLink href={href} label={label} />*/}
                    {/*            </li>*/}
                    {/*        ))}*/}
                    {/*    </ul>*/}
                    {/*</div>*/}

                </div>
            </div>

            {/* Affiliates strip */}
            <div style={{ borderTop: "1px solid rgba(255,255,255,0.06)", padding: "28px 0" }}>
                <div className="container-fluid px-5" style={{ maxWidth: "1100px", margin: "0 auto" }}>
                    <div className="d-flex flex-wrap align-items-center gap-3">
                        <span style={{ fontSize: "0.6rem", fontWeight: 600, letterSpacing: "0.2em", textTransform: "uppercase", color: "rgba(255,255,255,0.2)", marginRight: "8px" }}>
                            Affiliates
                        </span>
                        {[
                            { label: "AP",     href: "https://apstudent.collegeboard.org/home" },
                            { label: "CASE",   href: "https://www.case.org/" },
                            { label: "COIS",   href: "http://www.cois.org/" },
                            { label: "EARCOS", href: "https://www.earcos.org/" },
                            { label: "IB",     href: "https://www.ibo.org/" },
                            { label: "PTC",    href: "http://www.theptc.org" },
                            { label: "WASC",   href: "https://www.acswasc.org/" },
                        ].map(({ label, href }) => (
                            <a
                                key={label}
                                href={href}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-decoration-none"
                                style={{
                                    fontSize: "0.7rem",
                                    fontWeight: 600,
                                    letterSpacing: "0.08em",
                                    color: "rgba(255,255,255,0.25)",
                                    padding: "5px 12px",
                                    border: "1px solid rgba(255,255,255,0.1)",
                                    transition: "color 0.2s, border-color 0.2s",
                                }}
                                onMouseEnter={e => { e.currentTarget.style.color = "rgba(255,255,255,0.7)"; e.currentTarget.style.borderColor = "rgba(255,255,255,0.25)"; }}
                                onMouseLeave={e => { e.currentTarget.style.color = "rgba(255,255,255,0.25)"; e.currentTarget.style.borderColor = "rgba(255,255,255,0.1)"; }}
                            >
                                {label}
                            </a>
                        ))}
                    </div>
                </div>
            </div>

            {/* Copyright bar */}
            <div style={{ borderTop: "1px solid rgba(255,255,255,0.06)", padding: "20px 0" }}>
                <div className="container-fluid px-5 d-flex flex-column flex-sm-row align-items-center justify-content-between gap-2" style={{ maxWidth: "1100px", margin: "0 auto" }}>
                    <span style={{ fontSize: "0.7rem", color: "rgba(255,255,255,0.2)" }}>
                        © {new Date().getFullYear()} Extern Academy. All rights reserved.
                    </span>
                    <span style={{ fontSize: "0.7rem", color: "rgba(255,255,255,0.15)" }}>
                        2027 Cohorts — Applications open now.
                    </span>
                </div>
            </div>

        </footer>
    );
}

function CrossMark() {
    return (
        <div style={{ position: "relative", width: 18, height: 18, flexShrink: 0 }}>
            <div style={{ position: "absolute", width: "100%", height: "38%", top: "31%", left: 0, background: "#C0392B", borderRadius: 2 }} />
            <div style={{ position: "absolute", width: "38%", height: "100%", left: "31%", top: 0, background: "#C0392B", borderRadius: 2 }} />
        </div>
    );
}

function FooterLink({ href, label }) {
    return (
        <a
            href={href}
            className="text-decoration-none"
            style={{ fontSize: "0.875rem", color: "rgba(255,255,255,0.45)", transition: "color 0.2s" }}
            onMouseEnter={e => e.currentTarget.style.color = "#fff"}
            onMouseLeave={e => e.currentTarget.style.color = "rgba(255,255,255,0.45)"}
        >
            {label}
        </a>
    );
}
